
import moment from 'moment';
// import CREATE_USER_ACTIVITY from "../graphql/usersActivities/CreateUserActivity.gql"

export class UserActivity {
    // userId: String;
    // companyId: String;
    action: string;
    typeAction: string;
    userActivityStartDate: any;

    constructor(action, typeAction, userActivityStartDate) {
        // this.userId = userId
        // this.companyId = companyId
        this.action = action
        this.typeAction = typeAction
        this.userActivityStartDate = userActivityStartDate
    }

    async create(apollo, userId, companyId, objectId: string, overloadAction:string = undefined, accountingPeriodId = undefined, manualDuration = null) {
        // OBSOLETE
        return
        // const userActivityEndDateFormat = moment().format()
        // const userActivityEndDateDocumentValidation = moment(userActivityEndDateFormat)
        // let action = ""

        // if (!overloadAction) {
        //     action = this.action
        // } else if (this.action !== "") {
        //     action = overloadAction
        // }
        // if (action !== "") {
        //     switch (this.typeAction) {
        //     case "DOCUMENT":
        //         await apollo.mutate({
        //             mutation: CREATE_USER_ACTIVITY,
        //             variables: {
        //                 userId: userId,
        //                 document: objectId ? { connect: { id: objectId } } : undefined,
        //                 companyId: companyId,
        //                 duration: userActivityEndDateDocumentValidation.diff(this.userActivityStartDate, 'seconds'),
        //                 action: action,
        //                 type: this.typeAction,
        //                 date: this.userActivityStartDate
        //             }
        //         })
        //         break;
        //     case "RECONCILIATION":
        //         await apollo.mutate({
        //             mutation: CREATE_USER_ACTIVITY,
        //             variables: {
        //                 userId: userId,
        //                 reconciliation: action !== "DELETE" && objectId ? { connect: { id: objectId } } : undefined,
        //                 companyId: companyId,
        //                 duration: userActivityEndDateDocumentValidation.diff(this.userActivityStartDate, 'seconds'),
        //                 action: action,
        //                 type: this.typeAction,
        //                 date: this.userActivityStartDate
        //             }
        //         })
        //         break;
        //     case "ZTILL_RECEIPT":
        //         await apollo.mutate({
        //             mutation: CREATE_USER_ACTIVITY,
        //             variables: {
        //                 userId: userId,
        //                 zTillReceipt: action !== "DELETE" && objectId ? { connect: { id: objectId } } : undefined,
        //                 companyId: companyId,
        //                 duration: userActivityEndDateDocumentValidation.diff(this.userActivityStartDate, 'seconds'),
        //                 action: action,
        //                 type: this.typeAction,
        //                 date: this.userActivityStartDate
        //             }
        //         })
        //         break;
        //     case "EXPENSE_REPORT":
        //         await apollo.mutate({
        //             mutation: CREATE_USER_ACTIVITY,
        //             variables: {
        //                 userId: userId,
        //                 expenseReport: action !== "DELETE" && objectId ? { connect: { id: objectId } } : undefined,
        //                 companyId: companyId,
        //                 duration: userActivityEndDateDocumentValidation.diff(this.userActivityStartDate, 'seconds'),
        //                 action: action,
        //                 type: this.typeAction,
        //                 date: this.userActivityStartDate
        //             }
        //         })
        //         break;
        //     case "AUDIT_CHECK_RESULT":
        //         await apollo.mutate({
        //             mutation: CREATE_USER_ACTIVITY,
        //             variables: {
        //                 userId: userId,
        //                 companyId: companyId,
        //                 duration: manualDuration !== null ? manualDuration : userActivityEndDateDocumentValidation.diff(this.userActivityStartDate, 'seconds'),
        //                 action: action,
        //                 type: this.typeAction,
        //                 date: this.userActivityStartDate,
        //                 auditCheck: { connect: { key: objectId }},
        //                 accountingPeriod: { connect: { id: accountingPeriodId }}
        //             }
        //         })
        //         break;
        //     default:
        //         break;
        //     }
        // } else {
        //     debugger;
        // }
    }
}

export async function createUserActivity(apollo, userId, companyId, objectId: String, activity: any, overloadAction:string = undefined) {
    if (activity) {
        await activity.create(apollo, userId, companyId, objectId, overloadAction)
    } else {
        debugger
    }
}
